/* 184 C.1 — THE TIME-ENTRY PREFILL FOR AN E-MAIL, ONCE.
 *
 * `CaseEmailsSection.tsx` built this object inline for the drawer's
 * "+ Add time entry on selected" footer, for the CASE kind only; the collective
 * kind was refused with a toast that pointed at the inline Bill button, and the
 * dashboard's mount had the footer disabled. RULED (Laurent, 2026-09-12,
 * 184 (iii)): the footer works in CCV and on the dashboard — on the dashboard
 * through the matter question, then the time modal prefilled with the e-mail
 * and the chosen matter. So the object is composed HERE, for both kinds, and
 * the three hosts (the case section, the collective section, the dashboard)
 * call one function.
 *
 * The ONLY difference between the two kinds is the matter's key:
 * `TimeEntryModal.tsx` reads `form.ccId` for a collective entry and `form.caId`
 * for a case entry (165's `teMatter`). Everything else — the day, the five
 * minutes, CORR/EXCORR by direction, the subject, the move-stable `egid`
 * (Phase 32: `TimeEntry.emailGraphId` stores the internetMessageId, so the
 * double-log 409 keys on it), the two locks — is what the section wrote.
 */

import type { MatterRef } from "./emailArchiveClient";

/** What the prefill reads off a search row — the drawer's and the section's
 *  rows both carry these (their full shapes are wider and untyped). */
export interface EmailForTimeEntry {
  id?: string | null;
  date?: string | null;
  direction?: string | null;
  subject?: string | null;
  /** 209 §6 — the row's e-mail has no subject: `subject` then holds the LIST's
   *  word, in its reader's language (the server's), not the matter's. */
  subjectless?: boolean | null;
  internetMessageId?: string | null;
}

/* 209 §6 — « (NO SUBJECT) » SPEAKS THE TEXT'S LANGUAGE: a time entry's
   description is text of its matter, so an e-mail with no subject is named in
   the MATTER's language (`noSubject`, the caller's `tIn` of `email.no_subject`
   in it) — never the list's word, which is its reader's; none when the matter
   has no language (209 §5: never assumed — the description is left to type). */
export function emailLogTimePrefill(
  msg: EmailForTimeEntry,
  matter: MatterRef,
  coId: unknown,
  noSubject: string | null = null,
): Record<string, unknown> {
  return {
    ...(matter.kind === "cc" ? { ccId: matter.id } : { caId: matter.id }),
    coId,
    date: msg.date ? msg.date.slice(0, 10) : undefined,
    min: 5,
    type: msg.direction === "out" ? "CORR" : "EXCORR",
    desc: msg.subjectless ? (noSubject ?? "") : (msg.subject ?? ""),
    egid: msg.internetMessageId ?? msg.id ?? undefined,
    _caseFixed: true,
    _lockCo: true,
  };
}
